import { render } from "./dropdown.vue?vue&type=template&id=cff2fd5c"
import script from "./dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./dropdown.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "cff2fd5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cff2fd5c', script)) {
    api.reload('cff2fd5c', script)
  }
  
  module.hot.accept("./dropdown.vue?vue&type=template&id=cff2fd5c", () => {
    api.rerender('cff2fd5c', render)
  })

}

script.__file = "resources/scripts/components/ui/dropdown.vue"

export default script